// extracted by mini-css-extract-plugin
export default {"header":"PromotionSideBar_header__JJ1BR","body":"PromotionSideBar_body__0rYiv","promotion":"PromotionSideBar_promotion__fAvtu","button":"PromotionSideBar_button__Ywh3k"};